var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-notification-wrap" },
    [
      _c("div", { staticClass: "notification-toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-left" },
          [
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _vm.editing !== false
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-ghost",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.back($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-arrow-left" }),
                      _vm._v(" Back to list\n          ")
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "section-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.editing !== false
                      ? _vm.currentNotification.name || "Edit Notification"
                      : "Notifications"
                  ) +
                  "\n        "
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.addNotification($event)
              }
            }
          },
          [
            _c("i", { staticClass: "el-icon-plus" }),
            _vm._v(" Add Notification\n      ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        !_vm.editing
          ? _c("div", { key: "table", staticClass: "table-view" }, [
              !_vm.notifications.length
                ? _c("div", { staticClass: "empty-notifications" }, [
                    _c("div", { staticClass: "empty-icon" }, [
                      _c("i", { staticClass: "el-icon-bell" })
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v("No notifications yet")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Add a notification to send emails when this form is submitted."
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addNotification($event)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "el-icon-plus" }),
                        _vm._v(" Add your first notification\n          ")
                      ]
                    )
                  ])
                : _c(
                    "div",
                    { staticClass: "notification-list" },
                    _vm._l(_vm.notifications, function(notif, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "notification-row-card",
                          class: { "is-disabled": !notif.active }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "notif-status" },
                            [
                              _c("el-switch", {
                                attrs: { width: 36, value: notif.active },
                                on: {
                                  change: function(val) {
                                    return _vm.toggelNotification(index, val)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "status-label",
                                  class: notif.active ? "active" : "inactive"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        notif.active ? "Enabled" : "Disabled"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "notif-meta" }, [
                            _c("span", { staticClass: "notif-name" }, [
                              _vm._v(_vm._s(notif.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "notif-subject" }, [
                              _vm._v(_vm._s(notif.subject))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "notif-type-badge" }, [
                            _c("i", { staticClass: "el-icon-message" }),
                            _vm._v(" Email\n            ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "notif-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "icon-btn",
                                attrs: { title: "Edit" },
                                on: {
                                  click: function($event) {
                                    return _vm.editNotification(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-edit" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "icon-btn",
                                attrs: { title: "Duplicate" },
                                on: {
                                  click: function($event) {
                                    return _vm.duplicateNotification(index)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-copy-document"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.notifications.length > 1
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "icon-btn danger",
                                    attrs: { title: "Delete" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteNotification(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    0
                  )
            ])
          : _vm.currentNotification
          ? _c(
              "div",
              { key: "editor", staticClass: "editor-view" },
              [
                _c("div", { staticClass: "editor-section" }, [
                  _c("div", { staticClass: "section-eyebrow" }, [
                    _c("span", { staticClass: "section-step" }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "section-label" }, [
                      _vm._v("General")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "editor-section-body" }, [
                    _c("div", { staticClass: "field-row" }, [
                      _c(
                        "div",
                        { staticClass: "field-group field-group--grow" },
                        [
                          _c("label", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                  Notification Name\n                  "
                            ),
                            _c("span", { staticClass: "field-required" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "field-hint" }, [
                            _vm._v("Internal label — only visible to you.")
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: "e.g. Admin Alert, User Confirmation"
                            },
                            model: {
                              value: _vm.currentNotification.name,
                              callback: function($$v) {
                                _vm.$set(_vm.currentNotification, "name", $$v)
                              },
                              expression: "currentNotification.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field-group field-group--fixed" },
                        [
                          _c("label", { staticClass: "field-label" }, [
                            _vm._v("Type")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "field-hint" }, [
                            _vm._v("Notification channel.")
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "Select type" },
                              model: {
                                value: _vm.currentNotification.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.currentNotification, "type", $$v)
                                },
                                expression: "currentNotification.type"
                              }
                            },
                            [
                              _c(
                                "el-option",
                                { attrs: { label: "Email", value: "email" } },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "el-icon-message",
                                      staticStyle: { "margin-right": "6px" }
                                    }),
                                    _vm._v("Email")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.currentNotification.type === "email"
                  ? [
                      _c("div", { staticClass: "editor-section" }, [
                        _c("div", { staticClass: "section-eyebrow" }, [
                          _c("span", { staticClass: "section-step" }, [
                            _vm._v("2")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-label" }, [
                            _vm._v("Sender")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-desc" }, [
                            _vm._v(
                              'Shown in the recipient\'s inbox as the "from" identity.'
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "editor-section-body" }, [
                          _c("div", { staticClass: "field-row" }, [
                            _c(
                              "div",
                              { staticClass: "field-group field-group--half" },
                              [
                                _c("label", { staticClass: "field-label" }, [
                                  _vm._v("From Name")
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "field-hint" }, [
                                  _vm._v("The display name shown in the inbox.")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-stack" },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "Your Site Name" },
                                      model: {
                                        value: _vm.currentNotification.fromName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentNotification,
                                            "fromName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentNotification.fromName"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "merge-tag-row" },
                                      [
                                        _c("merge_tags", {
                                          attrs: { field: "fromName" },
                                          on: { insert: _vm.insertValue }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "field-group field-group--half" },
                              [
                                _c("label", { staticClass: "field-label" }, [
                                  _vm._v("From Address")
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "field-hint" }, [
                                  _vm._v("Must be a verified sending address.")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-stack" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "email",
                                        placeholder: "noreply@yoursite.com"
                                      },
                                      model: {
                                        value:
                                          _vm.currentNotification.fromAddress,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentNotification,
                                            "fromAddress",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentNotification.fromAddress"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "merge-tag-row" },
                                      [
                                        _c("merge_tags", {
                                          attrs: {
                                            filter: "email_address",
                                            field: "fromAddress"
                                          },
                                          on: { insert: _vm.insertValue }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "editor-section" }, [
                        _c("div", { staticClass: "section-eyebrow" }, [
                          _c("span", { staticClass: "section-step" }, [
                            _vm._v("3")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-label" }, [
                            _vm._v("Recipients")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-desc" }, [
                            _vm._v(
                              "Who receives this email. Use merge tags to dynamically reference form fields."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "editor-section-body" }, [
                          _c("div", { staticClass: "field-row" }, [
                            _c(
                              "div",
                              { staticClass: "field-group field-group--half" },
                              [
                                _c("label", { staticClass: "field-label" }, [
                                  _vm._v(
                                    "\n                    To\n                    "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "field-required" },
                                    [_vm._v("*")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "field-hint" }, [
                                  _vm._v("Primary recipient. Use "),
                                  _c("code", [_vm._v("{field_name}")]),
                                  _vm._v(" for dynamic values.")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-stack" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder:
                                          "{email} or admin@yoursite.com"
                                      },
                                      model: {
                                        value: _vm.currentNotification.to,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentNotification,
                                            "to",
                                            $$v
                                          )
                                        },
                                        expression: "currentNotification.to"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "merge-tag-row" },
                                      [
                                        _c("merge_tags", {
                                          attrs: { field: "to" },
                                          on: { insert: _vm.insertValue }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "field-group field-group--half" },
                              [
                                _c("label", { staticClass: "field-label" }, [
                                  _vm._v("Reply To")
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "field-hint" }, [
                                  _vm._v(
                                    "Replies from the recipient will go here."
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-stack" },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder:
                                          "{email} or support@yoursite.com"
                                      },
                                      model: {
                                        value: _vm.currentNotification.replyTo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.currentNotification,
                                            "replyTo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "currentNotification.replyTo"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "merge-tag-row" },
                                      [
                                        _c("merge_tags", {
                                          attrs: { field: "replyTo" },
                                          on: { insert: _vm.insertValue }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field-row field-row--compact" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "field-group field-group--half"
                                },
                                [
                                  _c("label", { staticClass: "field-label" }, [
                                    _vm._v(
                                      "\n                    CC\n                    "
                                    ),
                                    _c("span", { staticClass: "field-badge" }, [
                                      _vm._v("Optional")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      type: "email",
                                      placeholder: "cc@yoursite.com"
                                    },
                                    model: {
                                      value: _vm.currentNotification.cc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.currentNotification,
                                          "cc",
                                          $$v
                                        )
                                      },
                                      expression: "currentNotification.cc"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-group field-group--half"
                                },
                                [
                                  _c("label", { staticClass: "field-label" }, [
                                    _vm._v(
                                      "\n                    BCC\n                    "
                                    ),
                                    _c("span", { staticClass: "field-badge" }, [
                                      _vm._v("Optional")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: {
                                      type: "email",
                                      placeholder: "bcc@yoursite.com"
                                    },
                                    model: {
                                      value: _vm.currentNotification.bcc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.currentNotification,
                                          "bcc",
                                          $$v
                                        )
                                      },
                                      expression: "currentNotification.bcc"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "editor-section" }, [
                        _c("div", { staticClass: "section-eyebrow" }, [
                          _c("span", { staticClass: "section-step" }, [
                            _vm._v("4")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-label" }, [
                            _vm._v("Email Content")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "section-desc" }, [
                            _vm._v("What the recipient actually reads.")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "editor-section-body" }, [
                          _c("div", { staticClass: "field-group" }, [
                            _c("label", { staticClass: "field-label" }, [
                              _vm._v(
                                "\n                  Subject Line\n                  "
                              ),
                              _c("span", { staticClass: "field-required" }, [
                                _vm._v("*")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "field-hint" }, [
                              _vm._v(
                                "Keep it under 60 characters for best deliverability."
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-stack" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder:
                                      "New submission from {first_name}"
                                  },
                                  model: {
                                    value: _vm.currentNotification.subject,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentNotification,
                                        "subject",
                                        $$v
                                      )
                                    },
                                    expression: "currentNotification.subject"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "merge-tag-row" },
                                  [
                                    _c("merge_tags", {
                                      attrs: { field: "subject" },
                                      on: { insert: _vm.insertValue }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field-group" }, [
                            _c("label", { staticClass: "field-label" }, [
                              _vm._v("Message Body")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "field-hint" }, [
                              _vm._v("\n                  Plain text. Use "),
                              _c("code", [_vm._v("{all_fields}")]),
                              _vm._v(
                                " to include all submitted values,\n                  or specific field tags like "
                              ),
                              _c("code", [_vm._v("{email}")]),
                              _vm._v(", "),
                              _c("code", [_vm._v("{first_name}")]),
                              _vm._v(".\n                ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "input-stack input-stack--textarea"
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 10,
                                    placeholder:
                                      "Hi there,\n\nA new submission was received.\n\n{all_fields}\n\n— Your Site"
                                  },
                                  model: {
                                    value: _vm.currentNotification.message,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentNotification,
                                        "message",
                                        $$v
                                      )
                                    },
                                    expression: "currentNotification.message"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "merge-tag-row merge-tag-row--below-textarea"
                                  },
                                  [
                                    _c("merge_tags", {
                                      attrs: { field: "message" },
                                      on: { insert: _vm.insertValue }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "editor-footer" }, [
                  _c(
                    "button",
                    { staticClass: "btn btn-ghost", on: { click: _vm.back } },
                    [
                      _c("i", { staticClass: "el-icon-close" }),
                      _vm._v(" Cancel\n          ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.updateNotification }
                    },
                    [
                      _c("i", { staticClass: "el-icon-check" }),
                      _vm._v(" Save Notification\n          ")
                    ]
                  )
                ])
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }